import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import { Modal, Button, Alert } from 'react-bootstrap';
import is from 'is_js';
import * as moment from 'moment';
import * as settings from '../globals/settings'
import * as digitalIdApi from '../api/digitalIdApi'
import Footer from '../components/footer'

// FIXME Remove
import { fakeUser, fakeLabResults } from '../util/fakeData'
import { setUser, receiveLabResults, setErrorState, createDeviceId } from '../actions/api'

import NavBar from '../components/navbar'
import '../css/styles.css';

class SuccessfulRegScreen extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="container-full">
                <NavBar language={this.props.language}/>
                <div className="container justify-content-center align-items-center">
                    <div class="alert alert-info" role="alert">
                        <h5>{this.props.strings.REGISTER_SUCCESSFUL_LABEL}</h5>
                        <p>
                            {this.props.strings.REGISTER_SUCCESSFUL_MESSAGE_1}<br/>
                            {this.props.strings.REGISTER_SUCCESSFUL_MESSAGE_2}<br/><br/>
                            <b>{this.props.strings.REGISTER_SUCCESSFUL_MESSAGE_3}</b>
                            {this.props.strings.REGISTER_SUCCESSFUL_MESSAGE_4}<br/><br/>
                            {this.props.strings.REGISTER_SUCCESSFUL_MESSAGE_5}<br/>
                        </p>
                    </div>
                </div>
            <Footer />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authorizeUrl: state.auth.authorizeUrl,
        isLoadingLogin: state.auth.isLoadingLogin,
        isLoadingRegister: state.auth.isLoadingRegister,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        strings: state.language.strings,
        isError: state.api.isError,
    }
}

const ConnectedSuccessfulRegScreen = connect(
    mapStateToProps
)(SuccessfulRegScreen);

export default withRouter(ConnectedSuccessfulRegScreen);